import { DecimalPipe } from '@angular/common';

export class OperationalOperacion {

    static path = '/operaciones/';

    monto: number;
    cotizacion: number;
    monedaOrigen: number;
    monedaDestino: number;
    cliente: number;
    tipoOperacion: number;
    formaOperacion: number;
    precio: number;
    cantidad: number;

    constructor() {
    }
  }



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/operationalOperacion.model.ts